document.addEventListener('alpine:init', () => {
  Alpine.data('ThemeModule_DiscountProgressBar', () => {
    return {
      cartTotal: 0,
      tiers: [],
      totalNodes: 0,
      prevUnlocked: -1,

      init() {
        try {
          this.tiers = JSON.parse(this.$root.getAttribute('data-tiers') || '[]');
        } catch (e) {
          this.tiers = [];
        }
        this.totalNodes = this.tiers.length + 1;
        this.prevUnlocked = -1;

        // Use server-rendered cart total — no extra fetch needed
        this.cartTotal = parseInt(this.$root.getAttribute('data-cart-total') || '0', 10);

        this.$nextTick(() => {
          // Position nodes evenly
          var nodes = this.$root.querySelectorAll('[data-dpb-node-idx]');
          var lastIdx = this.totalNodes - 1;
          nodes.forEach((node) => {
            var idx = parseInt(node.getAttribute('data-dpb-node-idx'), 10);
            node.style.left = (lastIdx > 0 ? (idx / lastIdx) * 100 : 0) + '%';
          });
          this._render(false);
        });

        var self = this;

        window.addEventListener('cascade:modalcart:afteradditem', (e) => {
          self._updateFromEvent(e);
        });

        window.addEventListener('cascade:modalcart:cartqtychange', (e) => {
          self._updateFromEvent(e);
        });
      },

      _updateFromEvent(e) {
        var resp = e.detail && e.detail.response;
        if (!resp) return;

        // cartqtychange: response is full cart object with total_price
        if (typeof resp.total_price === 'number') {
          this.cartTotal = resp.total_price;
          this._render(true);
          return;
        }

        // afteradditem: response is added item + sections HTML
        // Extract updated cart total from the rendered cart-items section
        if (resp.sections && resp.sections['cart-items']) {
          var tmp = document.createElement('div');
          tmp.innerHTML = resp.sections['cart-items'];
          var bar = tmp.querySelector('[data-cart-total]');
          if (bar) {
            this.cartTotal = parseInt(bar.getAttribute('data-cart-total') || '0', 10);
            this._render(true);
            return;
          }
        }

        // Fallback: fetch cart data only if we couldn't extract it
        fetch('/cart.js', { credentials: 'same-origin' })
          .then((r) => r.json())
          .then((cart) => {
            this.cartTotal = cart.total_price;
            this._render(true);
          });
      },

      _fmt(cents) {
        return '\u20B9' + Math.round(cents / 100).toLocaleString('en-IN');
      },

      _nodePct(i) {
        var last = this.totalNodes - 1;
        return last > 0 ? (i / last) * 100 : 0;
      },

      _render(animate) {
        var root = this.$root;
        var fill = root.querySelector('[data-dpb-fill]');
        var heading = root.querySelector('[data-dpb-heading]');
        var subtext = root.querySelector('[data-dpb-subtext]');
        if (!fill || !heading || !subtext) return;

        var ct = this.cartTotal;
        var highestUnlocked = 0;
        var nextTier = null;

        for (var i = 0; i < this.tiers.length; i++) {
          if (ct >= this.tiers[i].amount) {
            highestUnlocked = i + 1;
          } else if (!nextTier) {
            nextTier = this.tiers[i];
          }
        }

        // Fill width — proportional between evenly spaced nodes
        var pct = 0;
        if (highestUnlocked >= this.tiers.length) {
          pct = 100;
        } else if (ct > 0) {
          var rIdx = highestUnlocked;
          var nIdx = highestUnlocked + 1;
          var rPct = this._nodePct(rIdx);
          var nPct = this._nodePct(nIdx);
          var segFrom = rIdx > 0 ? this.tiers[rIdx - 1].amount : 0;
          var segTo = this.tiers[rIdx].amount;
          var prog = Math.max(0, Math.min(1, (ct - segFrom) / (segTo - segFrom)));
          pct = rPct + (nPct - rPct) * prog;
        }
        fill.style.width = pct + '%';

        // Circles
        var chk = '<svg class="dpb__check" viewBox="0 0 16 16" fill="none"><path d="M3.5 8.5L6.5 11.5L12.5 5.5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';

        for (var i = 0; i < this.tiers.length; i++) {
          var node = root.querySelector('[data-dpb-node="' + (i + 1) + '"]');
          if (!node) continue;
          var circle = node.querySelector('.dpb__circle');
          var reached = ct >= this.tiers[i].amount;
          var wasReached = this.prevUnlocked >= (i + 1);

          if (reached) {
            node.classList.add('dpb__node--reached');
            circle.innerHTML = chk;
            if (reached && !wasReached && animate) {
              node.classList.add('dpb__node--just-reached');
              setTimeout(function(n) { n.classList.remove('dpb__node--just-reached'); }, 2500, node);
            }
          } else {
            node.classList.remove('dpb__node--reached', 'dpb__node--just-reached');
            circle.innerHTML = '';
          }
        }

        // Heading
        if (animate && this.prevUnlocked !== highestUnlocked) {
          root.classList.add('dpb--updating');
          setTimeout(() => {
            this._setText(heading, subtext, highestUnlocked, nextTier);
            root.classList.remove('dpb--updating');
          }, 300);
        } else {
          this._setText(heading, subtext, highestUnlocked, nextTier);
        }

        this.prevUnlocked = highestUnlocked;
      },

      _setText(h, s, unlocked, next) {
        if (unlocked === 0) {
          h.textContent = 'Unlock rewards';
          s.textContent = next
            ? 'Add ' + this._fmt(next.amount - this.cartTotal) + ' more to unlock ' + next.discount + '% off'
            : 'Add items to unlock discounts';
        } else if (unlocked >= this.tiers.length) {
          h.textContent = "You\u2019ve made it.";
          s.textContent = this.tiers[this.tiers.length - 1].discount + '% off applied to your order.';
        } else {
          h.textContent = this.tiers[unlocked - 1].discount + '% off unlocked!';
          if (next) s.textContent = 'Add ' + this._fmt(next.amount - this.cartTotal) + ' more to unlock ' + next.discount + '% off';
        }
      },
    };
  });
});
